import { render, staticRenderFns } from "./MolecularForceViz.vue?vue&type=template&id=1b7ffe93&scoped=true"
import script from "./MolecularForceViz.vue?vue&type=script&lang=js"
export * from "./MolecularForceViz.vue?vue&type=script&lang=js"
import style0 from "./MolecularForceViz.vue?vue&type=style&index=0&id=1b7ffe93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ffe93",
  null
  
)

export default component.exports